<template>
  <el-dialog title="合同附件" :visible.sync="DialogVisible" width="800px" :close-on-click-modal="false" :close-on-press-escape="false">
    <contract-file v-if="DialogVisible" :contract-num="contractNum" />
    <span slot="footer" class="dialog-footer">
      <el-button type="default" @click="DialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script type="es6">
import contractFile from './contractFile';
export default {
  data () {
    return {
      DialogVisible: false,
      contractNum: ''
    };
  },
  components: {
    contractFile
  },
  computed: {},
  methods: {
    showFile (code) {
      this.contractNum = code;
      this.DialogVisible = true;
    }
  },
  mounted () {

  }
};
</script>
<style lang="less"></style>
